export default "__VITE_ASSET__CM3sfqwE__"